var isExternal = false;
var railList = window.internalRailStationsList || [];
var railSelector = ".js-domestic-rail";
var documentWidth = screen.width;
var datePickerMode = localStorage.getItem("datePickerMode") ? Number(localStorage.getItem("datePickerMode")) : 2;

// Traveller Count Form
var sum;
var youngs = ``;
var temp = true;

$(window).resize(function () {
  documentWidth = screen.width;
});

$(function () {
  let timeOut = setTimeout(() => {
    $("#internal-rail-oneWay").prop('checked',true)
  clearTimeout(timeOut)
  }, 0)

  railDatePicker();

  $(".js-exclusive-compartment").change((event) => {
    if (event.target.checked) {
      $(".js-domestic-rail").find(".rail-booking__item--travellers").show();
      $(".js-car-transfer").prop('checked', false);    
    }
  })
 
  $(".js-car-transfer").change((event) => {
    if (event.target.checked) {
      $(".js-domestic-rail").find(".rail-booking__item--travellers").hide();
      $(".js-exclusive-compartment").prop('checked', false);
    }
    else {
      $(".js-domestic-rail").find(".rail-booking__item--travellers").show();
    }
  })

  let radioCheckedValue = $(".js-rail .js-routes-select input:radio:checked").val();
  railRoutesTypeCheck(radioCheckedValue);

  $(".js-time-inner").click(selectTime);

  $(".js-rail .js-auto-search").each(function () {
    autoSearchRail($(this));
  });

  $(".js-rail .js-economy-target").each(function () {
    calcSum($(this));
  });

  $(".js-routes-select").on("change", "input", function () {
    railRoutesTypeCheck($(this).val(), $(this));
  });

  // Traveller Menu Close
  $(document).mouseup(function (e) {
    // if the target of the click isn't the container...
    if (
      !$(".js-economy-target").is(e.target) &&
      $(".js-economy-target").has(e.target).length === 0
    ) {
      var validToClose = true;
      if ($(".js-passenger-young .js-number-passenger").text() !== "0") {
        $(".js-young-age").each(function () {
          if (!$(this).val()) {
            $(this).next().fadeIn();
            validToClose = false;
          } else {
            $(this).next().fadeOut();
          }
        });
      }

      if ($(".js-passenger-young .js-number-passenger").text() !== "0") {
        $(".js-young-age").each(function () {
          if ($(this).val() > 27 || $(this).val() < 0) {
            $(this).next().next().fadeIn();
            $(".js-passenger-young-period").addClass("err");
            validToClose = false;
          } else {
            $(this).next().next().fadeOut();
            $(".js-passenger-young-period").removeClass("err");
          }
        });
      }

      if (validToClose && documentWidth > 992) {
        // ... nor a descendant of the container
        $(".js-rail-travelers").fadeOut();
        $(".js-economy-target .js-rail-booking-field").removeClass(
          "rail-booking__item--border--active"
        );
      }
    }
  });

  $(document).mouseup(function (e) {
    if (
      !$(".js-time-list").is(e.target) &&
      $(".js-time-list").has(e.target).length === 0
    ) {
      if (documentWidth > 992) {
        // ... nor a descendant of the container
        $(".js-time-list").fadeOut();
      } else {
        $(".js-rail-travelers").removeClass("show-tmenu");
      }
    }
  });

  // Search Btn
  $(".js-rail .js-rail-search").click(searchRail);

  // Exchange Btn For Swaping Values
  $(".js-domestic-rail-exchange-btn").click(domesticRailExchange);

  // Show More Description In Property
  $(".js-show-more").click(function () {
    $(".js-property-footer-content").toggleClass("auto-height");
    $(this).toggleClass("active");
  });

  $(".js-rail-tab").click(function () {
    railRoutesTypeCheck(radioCheckedValue);
  });

  $(".js-rail .js-count-box .js-max").click(function () {
    var $this = $(this).closest(".js-rail-travelers");
    youngs = `
        <div class="js-young-wrapper rail-booking__travellers-description-youngs">
            <div>
                <label>سن جوان</label>
            </div>
            <div>
                <input type="text" class="js-young-age">
                <span class="js-young-err">لطفا سن جوان را وارد نمایید</span>
                <span class="js-young-err">سن وارد شده برای جوان صحیح نمی باشد</span>
            </div>
        </div>
        `;
    if (sum < 9) {
      $this.find(".js-validation-economy").text("");
      var num = Number($(this).parent().find(".js-number-passenger").text());
      var temp = num + 1;

      if ($(this).closest("li").hasClass("js-passenger-adult")) {
        $(this).parent().find(".js-number-passenger").text(temp);
        $(this)
          .closest(".js-economy-target")
          .find(".js-rail-adults-number")
          .text(temp);
      } else if ($(this).closest("li").hasClass("js-passenger-young")) {
        $(this).parent().find(".js-number-passenger").text(temp);
        $(this)
          .closest(".js-economy-target")
          .find(".js-rail-young-number")
          .text(temp);
        if (temp >= 1) {
          $(".js-young").fadeIn();
          if (isExternal) {
            $(this)
              .closest(".js-rail-travelers")
              .find(".js-rail-booking-infant-description")
              .slideDown();
            $(".js-rail-booking-infant-description").append(youngs);
          }
        }
      } else {
        if (temp >= 1) {
          $(this).parent().find(".js-number-passenger").text(temp);
          $(this)
            .closest(".js-economy-target")
            .find(".js-rail-old-number")
            .text(temp);
          $(".js-old").fadeIn();
        }
      }

      calcSum($(this).closest(".js-economy-target"));
    } else {
      $this
        .find(".js-validation-economy")
        .text("تعداد کل مسافرین نمیتواند بیشتر از 9 نفر باشد");
    }
  });

  $(".js-rail .js-count-box .js-min").click(function () {
    var $this = $(this).closest(".js-economy-target");
    $(".js-validation-economy").text("");

    var num = Number($(this).parent().find(".js-number-passenger").text());

    var min = Number($(this).parent().find(".js-number-passenger").data("min"));

    var temp = num > min ? num - 1 : num;
    var babyNumber = Number(
      $(this)
        .closest(".js-rail-travelers")
        .find(".js-passenger-young")
        .find(".js-number-passenger")
        .text()
    );
    var adultNumber = Number(
      $(this).parent().find(".js-number-passenger").text()
    );
    if ($(this).closest("li").hasClass("js-passenger-adult")) {
      if (babyNumber < adultNumber) {
        $(this).parent().find(".js-number-passenger").text(temp);
        $this.find(".js-rail-adults-number").text(temp);
      } else {
        $(".js-validation-economy").text(
          "تعداد بزرگسال نمی تواند کمتر از تعداد نوزاد باشد"
        );
      }
    } else if (
      $(this).closest(".js-passenger-list").hasClass("js-passenger-young")
    ) {
      $(this).parent().find(".js-number-passenger").text(temp);
      $this.find(".js-rail-young-number").text(temp);
      if (temp === 0) {
        $(".js-young").fadeOut();
        if (isExternal) {
          $(this)
            .closest(".js-rail-travelers")
            .find(".js-rail-booking-infant-description")
            .slideUp();
        }
      }
    } else {
      $(this).parent().find(".js-number-passenger").text(temp);
      $this.find(".js-rail-old-number").text(temp);
      if (temp === 0) {
        $(".js-old").fadeOut();
      }
    }
    $(".js-young-wrapper:last-child").remove();
    calcSum($(this).closest(".js-booking-container"));
  });

  // Events control in mobile
  $(".js-rail").delegate(".js-close-auto-complete", "click", function () {
    $(".js-rail-city").removeClass("show-mobile");
    $(".js-rail-search-list>ul").hide();
    $("html").removeClass("no-scroll");
  });

  // Show DatePicker/autoComplete List when click on parent box
  $(document).delegate(".js-rail-booking-field", "click", function (e) {
    $(this).addClass("rail-booking__item--border--active");
    if ($(this).find(".js-auto-search").length) {
      if (
        !e.target.closest(".js-auto-search") &&
        !e.target.closest(".js-rail-search-list") &&
        !e.target.closest(".js-close-auto-complete")
      ) {
        $(this).find(".js-auto-search").trigger("focus");
      }
    }

    if (
      $(this).find(".js-pick-date-rail").length &&
      !e.target.closest(".js-pick-date-rail")
    ) {
      $(this).find(".js-pick-date-rail.hasDatepicker").datepicker("show");
      setTimeout(function () {
        document.activeElement.blur()
      }, 16);
    }

    if (
      $(this).find(".js-pick-date2-rail").length &&
      !e.target.closest(".js-pick-date2-rail")
    ) {
      $(this).find(".js-pick-date2-rail.hasDatepicker").datepicker("show");
      setTimeout(function () {
        document.activeElement.blur()
      }, 16);
    }
  });

  $(document).delegate(".js-economy-target", "click", function (e) {
    if (
      documentWidth < 992 &&
      !$(e.target).hasClass("icon-close") &&
      !$(e.target).hasClass("js-close-tmenu")
    ) {
      $(".js-rail-travelers").fadeIn();
    }
  });

  //search input layout in mobile
  $(".js-rail").delegate(".js-rail-booking-field", "click", function () {
    if (documentWidth < 992) {
      $(this).closest(".js-rail-city").addClass("show-mobile");
    }
    $(this).closest(".js-rail-city").find("input").trigger("focus");
    $(this).closest(".js-rail-city").find("input").trigger("search");
  });

  $(document).delegate(".js-young-age", "blur", function () {
    if (!$(this).val()) {
      $(this).next().fadeIn();
    } else {
      $(this).next().fadeOut();
    }
  });

  $(".js-rail-domestic-origin-location").click(() => {
    $(".js-rail-domestic-origin-location").trigger("focus")
  })

  // init autoComplete
  $(".js-rail-domestic-origin-location")
    .autocomplete({
      minLength: 0,
      source: function (request, response) {
        if (request.term === "") {
          var items = railList && railList.length ? railList : [];
          var newItems = [];
          items.map(function (item) {
            var rail = {
              clientCode: item.clientCode,
              code: item.code,
              country: item.country,
              id: item.id,
              label: item.persianLabel,
              engLabels: item.label,
              localLabel: item.localLabel,
              persianLabel: item.persianLabel,
              type: item.type,
            };
            newItems.push(rail);
          });
          response(newItems);
        } else {
          var url = getResult($(".js-rail-domestic-origin-location"));
          $.getJSON(url).done(function (serverResponse) {
            response(serverResponse.model);
          });
        }
      },

      appendTo: $(".js-rail-domestic-origin-location").next(),

      search: function () {
        $(this).closest(".js-rail-booking-input").addClass("is-open");

        if (window.innerWidth < 993) {
          $("html").addClass("no-scroll");
        }
      },

      select: function (event, ui) {
        var input;
        if (ui.item.type === "city") {
          input = ui.item.persianLabel;
        } else if (ui.item.type === "station") {
          input = ui.item.label;
          $(this).attr("station", "true");
        }
        $(this).attr("data-code", ui.item.clientCode);
        $(this).attr("data-value", ui.item.title);
        $(this).val();
        $(this).attr("placeholder", input);
        $(this).closest(".js-rail-booking-input").removeClass("is-open");

        // if (documentWidth > 992) {


        $(this).closest(".js-section-active").find(".js-rail-domestic-destinations-location").autocomplete("search")

        let timeOut = setTimeout(() => {
          $(this).closest(".js-section-active").find(".js-rail-domestic-destinations-location").trigger("focus");
          clearTimeout(timeOut)
        }, 0)


        // $(this).closest(".js-section-active").find(".js-rail-domestic-destinations-location").autocomplete("search")
        // }
      },

      open: function () {
        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");
        //off autocomplete in chrome
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $(this).attr("autocomplete", "off");
        }
        var inputObj = $(this);
        inputObj
          .next(".js-autocomplete-list")
          .children("ul")
          .css({
            top: "+=" + 12,
          });
      },

      close: function () {
        $("html").removeClass("no-scroll");
      },

    })
    .bind("focus", function () {
      $(this).val("");
      $(this).autocomplete("search");
    })
    .bind("blur", function () {
      $(this).val($(this).attr("placeholder"));
    })
    .autocomplete("instance")._renderItem = function (ul, item) {
      var input;
      var allStation = "";
      var icon = "";
      if (item.type === "city") {
        icon = "<i class=' icon-map'></i>";
        input = '<div>' + item.persianLabel;
        allStation = "<span>همه ایستگاه‌ها</span>" + "</div>";
      } else if (item.type === "station") {
        icon = "<i class=' icon-train'></i>";
        input = '<div>' + '<span>' + item.label + '</span>' + "<span>ایستگاه</span>" + "</div>";
      }
      return $("<li>")
        .append(icon + input + allStation)
        .appendTo(ul);
    };

  $(".js-rail-domestic-destinations-location").click(() => {
    $(".js-rail-domestic-destinations-location").trigger("focus")
  })


  $(".js-rail-domestic-destinations-location")
    .autocomplete({
      minLength: 0,
      source: function (request, response) {
        if (request.term === "") {
          var items = railList && railList.length ? railList : [];
          var newItems = [];
          items.map(function (item) {
            var rail = {
              clientCode: item.clientCode,
              code: item.code,
              country: item.country,
              id: item.id,
              label: item.persianLabel,
              engLabels: item.label,
              localLabel: item.localLabel,
              persianLabel: item.persianLabel,
              type: item.type,
            };
            newItems.push(rail);
          });
          response(newItems);
        } else {
          var url = getResult($(".js-rail-domestic-destinations-location"));
          $.getJSON(url).done(function (serverResponse) {
            response(serverResponse.model);
          });
        }
      },

      appendTo: $(".js-rail-domestic-destinations-location").next(),

      search: function () {
        $(this).closest(".js-rail-booking-input").addClass("is-open");

        if (window.innerWidth < 993) {
          $("html").addClass("no-scroll");
        }
      },

      select: function (event, ui) {
        var input;
        if (ui.item.type === "city") {
          input = ui.item.persianLabel;
        } else if (ui.item.type === "station") {
          input = ui.item.label;
          $(this).attr("station", "true");
        }
        $(this).attr("data-code", ui.item.clientCode);
        $(this).attr("data-value", ui.item.label);
        $(this).val();
        $(this).attr("placeholder", input);
        $(this).closest(".js-rail-booking-input").removeClass("is-open");

        // if (window.innerWidth > 992) {
        document.querySelector(".js-rail-booking-field").click()
        // }

        $("html").removeClass("no-scroll");
      },

      open: function () {
        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");
        //off autocomplete in chrome
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $(this).attr("autocomplete", "off");
        }
        var inputObj = $(this);
        inputObj
          .next(".js-autocomplete-list")
          .children("ul")
          .css({
            top: "+=" + 12,
          });
      },

      close: function (e, ui) {
        $("html").removeClass("no-scroll");
      },

    })
    .bind("focus", function () {
      $(this).val("");
      $(this).autocomplete("search");
    })
    .bind("blur", function () {
      $(this).val($(this).attr("placeholder"));
    })
    .autocomplete("instance")._renderItem = function (ul, item) {
      var input;
      var allStation = "";
      var icon = "";
      if (item.type === "city") {
        icon = "<i class=' icon-map'></i>";
        input = '<div>' + item.persianLabel;
        allStation = "<span>همه ایستگاه‌ها</span>" + "</div>";
      } else if (item.type === "station") {
        icon = "<i class=' icon-train'></i>";
        input = '<div>' + '<span>' + item.label + '</span>' + "<span>ایستگاه</span>" + "</div>";
      }
      return $("<li>")
        .append(icon + input + allStation)
        .appendTo(ul);
    };

  // close location
  $(".js-rail-booking-input").delegate(
    ".js-close-location-list",
    "click",
    function () {
      $(".js-rail-domestic-origin-location").autocomplete("close");
      $(this).closest(".js-rail-booking-input").removeClass("is-open");
      $("html").removeClass("no-scroll");
    }
  );

  // show datepicker or autocomplete list when click on parent box
  $(document).delegate(".js-rail-booking-input", "click", function (e) {
    if ($(this).find(".js-rail-origin-location").length) {
      if (
        !e.target.closest(".js-rail-origin-location") &&
        !e.target.closest(".js-autocomplete-list") &&
        !e.target.closest(".js-close-location-list")
      ) {
        $(this).find(".js-rail-origin-location").trigger("focus");
      }
    }

    if (
      $(this).find(".js-pick-date").length &&
      !e.target.closest(".js-pick-date")
    ) {
      $(this).find(".js-pick-date.hasDatepicker").datepicker("show");
    }
  });

  $(document).delegate(".js-rail-booking-input", "focus", function () {
    // if ($(window).width() > 992) {
    $(this).closest(".rail-booking__input").addClass("is-open");
    // }
  });

  $(document).delegate(".js-rail-booking-input", "blur", function () {
    // if ($(window).width() > 992) {
    $(this).closest(".rail-booking__input").removeClass("is-open");
    // }
  });

  //economy click
  $(document).delegate(
    ".js-economy-target .js-rail-booking-field",
    "click",
    function () {
      if (documentWidth > 992) {
        $(this).addClass("rail-booking__item--border--active");
        $(this).children(".js-rail-travelers").fadeIn();
      } else {
        // $("html").addClass("no-scroll");
        $(this).next(".js-rail-travelers").toggleClass("show-mobile");
      }
    }
  );

  //remove input text
  $(document).delegate(".js-close-tmenu", "click", function () {
    var validToClose = true;
    if ($(".js-passenger-young .js-number-passenger").text() !== "0") {
      $(".js-young-age").each(function () {
        if (!$(this).val()) {
          $(this).next().fadeIn();
          validToClose = false;
        } else {
          $(this).next().fadeOut();
        }
      });
    }

    if ($(".js-passenger-young .js-number-passenger").text() !== "0") {
      $(".js-young-age").each(function () {
        if ($(this).val() > 27 || $(this).val() < 0) {
          $(this).next().next().fadeIn();
          $(".js-passenger-young-period").addClass("err");
          validToClose = false;
        } else {
          $(this).next().next().fadeOut();
          $(".js-passenger-young-period").removeClass("err");
        }
      });
    }
    if (validToClose) {
      $("html").removeClass("no-scroll");
      $(".js-rail-travelers").fadeOut();
    }
  });

  $(document).delegate(".js-search-filed", "focus", function () {
    if (documentWidth > 992) {
      $(this)
        .closest(".booking-search__field")
        .addClass("rail-booking__item--border--active");
    }
  });

  $(document).delegate(".js-search-filed", "blur", function () {
    if (documentWidth > 992) {
      $(this)
        .closest(".rail-booking__item--border")
        .removeClass("rail-booking__item--border--active");
    }
  });
});

//***/ Functions ***//

// Update auto complete after type
function getResult(input) {
  var dataUrl;
  if (isExternal) {
    dataUrl = "/fa/rail/getPlaces/?Keyword=";
  } else {
    dataUrl = "/fa/rail/getPlaces/?SearchType=2&Keyword=";
  }

  if (input.val()) {
    dataUrl += input.val();
  }
  return dataUrl;
}

// Exchange Btn
function domesticRailExchange() {
  var input1 = $(".js-rail-domestic-origin-location");
  var input2 = $(".js-rail-domestic-destinations-location");

  var inputList1 = input1.next(".js-autocomplete-list");
  var inputList2 = input2.next(".js-autocomplete-list");

  $(input2).swap(input1);

  $(inputList2).swap(inputList1);

  input1
    .removeClass("js-rail-domestic-origin-location")
    .addClass("js-rail-domestic-destinations-location");
  input2
    .removeClass("js-rail-domestic-destinations-location")
    .addClass("js-rail-domestic-origin-location");
}

// init datePicker
function railDatePicker() {
  setTimeout(function () {
    $(".js-rail .js-rail-departure").pickDate({
      dateFormat: "yy/mm/dd",
      dateFormatEn: "yy M dd",
      nextText: "ماه بعد",
      prevText: "ماه قبل",
      nextTextEn: "next month",
      prevTextEn: "prev month",
      changeMonthAllow: false,
      changeYearAllow: false,
      showButtonPanel: true,
      isDependenceDates: false,
      showCurrentAtPos: 0,
      numberOfMonths: $(window).width() > 991 ? 2 : 1,
      minDate: -0,
      customClass: "lightTheme",
      showAllMonthsinList: false,
      langType: datePickerMode === 1 ? '':'fa',
      blurInmobile: true,
      dayNamesShortFa: [
        "1شنبه",
        "2شنبه",
        "3شنبه",
        "4شنبه",
        "5شنبه",
        "جمعه",
        "شنبه",
      ],
      dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
      enterDateTitle: "تاریخ رفت",
      exitDateTitle: "تاریخ برگشت",
      enterDateTitleEn: "Departure date",
      exitDateTitleEn: "Retun date",
      fillHidden: {
        enable: true,
        outPut: "en", //en | Dependent_On_SelectedDate | fa
        customformatInhidden: "YYYY-MM-DD",
      },

      onSelectEvent: function () {
        var $this = $(this);
        var routeType = $this
          .closest(".js-rail")
          .find(".js-routes-select input:checked")
          .val();

        setTimeout(function () {
          if (routeType === "twoWay" && $this.is(".js-pick-date-rail")) {
            $this
              .closest(".js-rail-departure")
              .find(".js-pick-date2")
              .trigger("focus");
          }
        }, 10);

        $('.js-title--before-select').hide();
        $('.js-title--after-select').show();
        $('.js-rail-departure').addClass('date-selected');
      },
    });
  }, 100);
}

// Calc TotalPassengers
function calcSum(obj) {
  sum = 0;
  obj.find("li.js-passenger-list .js-number-passenger").each(function () {
    sum += Number($(this).text());
    obj.find(".js-traveles-number .js-number").text(sum);
  });
}



// Check Routes Type
function railRoutesTypeCheck(value, obj) {
  if (value === "rail-twoWay") {
    $(obj).closest(".js-rail").find(".js-rail-return-date").show();

    // $(".js-one-or-two-route-container").show().addClass("js-section-active");

    $(".js-rail-departure").addClass("two-calendar");

    sum = $(
      ".js-booking-section.active .js-one-or-two-route-passengers-sum"
    ).text();
  } else if (value === "rail-oneWay") {
    sum = $(
      ".js-booking-section.active .js-one-or-two-route-passengers-sum"
    ).text();

    $(obj).closest(".js-rail").find(".js-rail-return-date").hide();

    $(".js-rail-departure").removeClass("two-calendar");

    // $(".js-one-or-two-route-container").show().addClass("js-section-active");
  }
}

// Search Rail Base On Entered Data
function searchRail() {
  var localStorageKey = `${window.prefixSearchHistory}-${$('.js-search-holder-landing').attr('id') ||
    $(this).closest('.js-tab-nav').find(".js-tab-content>div.active").attr('id')
    }`
  var searchHistoryItem = {
    value: {},
    baseUrl: '',
    expire: ''
  }

  var fieldsEquelValidation = true;
  var valid = true;
  var baseUrl = isExternal ? "/fa/rail/int/" : "/fa/rail/dom/";
  var youngPassengerAgeIsValid = true;
  var adult =
    Number(
      $(this)
        .siblings(".js-economy-target")
        .find(".js-rail-adults-number")
        .text()
    ) || 1;
  var elder = Number(
    $(this).siblings(".js-economy-target").find(".js-rail-old-number").text()
  );
  var youngCount = Number(
    $(this).siblings(".js-economy-target").find(".js-rail-young-number").text()
  );
  var selectedTime;
  var returnSelectedTime;
  var toCityInput;
  var fromCityInput;
  var departureClock;
  var returnClock;
  var fromStationInput;
  var isExclusive = $(".js-exclusive-compartment").prop("checked");
  var classType = $(".js-list-type:checked").val();
  var carTransfer = $(".js-car-transfer:checked").val();

  $(this).closest(".js-rail").find(".error-message").remove();

  fromCityInput = isExternal
    ? $(".js-rail-origin-location").attr("data-code")
    : $(".js-rail-domestic-origin-location").attr("data-code");
  fromStationInput = isExternal
    ? $(".js-rail-origin-location").attr("station")
    : $(".js-rail-domestic-origin-location").attr("station");
  toCityInput = isExternal
    ? $(".js-rail-destinations-location").attr("data-code")
    : $(".js-rail-domestic-destinations-location").attr("data-code");
  var toCityStaionInput = isExternal
    ? $(".js-rail-destinations-location").attr("station")
    : $(".js-rail-domestic-destinations-location").attr("station");

  departureClock = selectedTime
    ? moment(selectedTime, "hh:mm").format("HH-mm")
    : "";

  returnClock = returnSelectedTime
    ? moment(returnSelectedTime, "hh:mm").format("HH-mm")
    : "";

  // Check If Origin & Destination Are The Same
  if ((toCityInput === fromCityInput) && toCityInput && fromCityInput) {
    valid = false;
    fieldsEquelValidation = false;
  }

  searchHistoryItem.value.routeType = $(".js-rail").find(".js-routes-select input:checked").val() // rail-oneWay | rail-twoWay

  // Check If Origin Is Selected
  if (fromCityInput) {
    baseUrl += fromCityInput + "-";
    let fromCityElement = isExternal
      ? $(".js-rail-origin-location")
      : $(".js-rail-domestic-origin-location")
    searchHistoryItem.value.fromCity = {
      code: fromCityElement.data('code'),
      title: fromCityElement.attr('placeholder'),
      station: Boolean(fromCityElement.attr("station"))
    }
  } else {
    valid = false;
  }

  // Check If Destination Is Selected
  if (toCityInput) {
    // baseUrl += $(this).closest(".js-rail").find(".js-rail-to-city").data("code");
    baseUrl += toCityInput;
    let toCityElement = isExternal
      ? $(".js-rail-destinations-location")
      : $(".js-rail-domestic-destinations-location")
    searchHistoryItem.value.toCity = {
      code: toCityElement.data('code'),
      title: toCityElement.attr('placeholder'),
      station: Boolean(toCityElement.attr("station"))
    }
  } else {
    valid = false;
  }

  // Check If Origin Is Station
  if (fromStationInput === "true") {
    baseUrl += "/?ot=1";
  } else {
    baseUrl += "/?ot=2";
  }

  // Check If Destination Is Station
  if (toCityStaionInput === "true") {
    baseUrl += "&dt=1";
  } else {
    baseUrl += "&dt=2";
  }

  !isExternal ? (baseUrl += "&ST=2") : "";

  // Went Date
  var startDateValue = $(this).closest(".js-rail").find(".js-pick-date-rail");
  if (startDateValue.val() && startDateValue.next().val()) {
    var departureDate = startDateValue.next().val()
      ? moment(startDateValue.next().val(), "YYYY-MM-DD").format("YYYY/MM/DD")
      : "";
    baseUrl += "&d=" + departureDate;
    searchHistoryItem.value.startDateValue = startDateValue.next().val()
    searchHistoryItem.expire = startDateValue.next().val()
  } else {
    valid = false;
  }

  // Return Date
  if (
    $(this)
      .closest(".js-rail")
      .find('.js-routes-select input:radio[name*="routeType"]:checked')
      .val() === "rail-twoWay"
  ) {
    var endDateValue = $(this).closest(".js-rail").find(".js-pick-date2-rail");

    if (endDateValue.val() && endDateValue.next().val()) {
      var returnDate = endDateValue.next().val()
        ? moment(endDateValue.next().val(), "YYYY-MM-DD").format("YYYY/MM/DD")
        : "";
      baseUrl += "&r=" + returnDate;
      searchHistoryItem.value.endDateValue = endDateValue.next().val()
    } else {
      valid = false;
    }
  }

  if (isExternal) {
    if (adult > 0) {
      for (var i = 0; i < adult; i++) {
        baseUrl += "&p=28";
      }
    }

    if (elder > 0) {
      for (var i = 0; i < elder; i++) {
        baseUrl += "&p=60";
      }
    }

    var youngsArr = [];
    $(".js-young-age").each(function () {
      youngsArr.push(Number($(this).val()));
    });

    if (youngsArr.length > 0) {
      for (var i = 0; i < youngsArr.length; i++) {
        var age = convertFaToEnNumber(youngsArr[i]);
        if (Number(age) && Number(age) <= 27 && Number(age) > 0) {
          baseUrl += "&p=" + age;
        } else {
          valid = false;
          youngPassengerAgeIsValid = false;
          youngsArr[i].isValid = false;
        }
      }
      searchHistoryItem.value.youngsArr = [...youngsArr]
    }
  } else {
    baseUrl += "&AC=" + adult;
    elder ? (baseUrl += "&CC=" + elder) : "";
    youngCount ? (baseUrl += "&IC=" + youngCount) : "";
  }
  // If Compartment Is Exclusive
  if (!isExternal) {
    if (isExclusive) {
      baseUrl += "&ex=True";
    } else {
      baseUrl += "&ex=False";
    }
    searchHistoryItem.value.exclusive = isExclusive
  }

  if (!isExternal) {
    if (carTransfer) {
      baseUrl += "&ct=4";
    } else if (classType === "family-class") {
      baseUrl += "&ct=3";
    } else if (classType === "womens-only-class") {
      baseUrl += "&ct=2";
    } else if (classType === "mens-only-class") {
      baseUrl += "&ct=1";
    }
  }

  searchHistoryItem.value.passenger = {
    adult: adult,
    child: elder,
    infant: youngCount
  }

  searchHistoryItem.value.classType = classType // family-class | mens-only-class | womens-only-class

  var isJalali =
    $(this).closest(".js-rail").find(".js-pick-date-rail").attr("data-lang") ===
    "fa";

  if (isJalali) {
    baseUrl += "&dpf=fa";
  } else {
    baseUrl += "&dpf=en";
  }

  if (!valid) {
    if (!fieldsEquelValidation) {
      $(this)
        .closest(".js-rail")
        .append(
          "<span class='error-message'>فیلد مبدا و مقصد نمی‌تواند یکسان باشد</span>"
        );
    } else if (!youngPassengerAgeIsValid) {
      $(this)
        .closest(".js-rail")
        .append(
          "<span class='error-message'>سن وارد شده برای جوان صحیح نمی باشد</span>"
        );
    } else {
      $(this)
        .closest(".js-rail")
        .append(
          "<span class='error-message'>لطفا فیلدها را کامل نمایید</span>"
        );
    }
    return false;
  } else {
    searchHistoryItem.baseUrl = baseUrl

    window.updateLocalStorage(localStorageKey, searchHistoryItem)
    window.location.assign(baseUrl);
  }
}

function selectTime() {
  var routeType = $(this)
    .closest(".js-rail")
    .find(".js-routes-select input:checked")
    .val();

  if (routeType === "rail-twoWay") {
    returnSelectedTime = $(this).text();
    $(".js-return-time-label").text("," + returnSelectedTime);
  } else if (routeType === "rail-oneWay") {
    selectedTime = $(this).text();
    $(".js-time-label").text("," + selectedTime);
  }

  $(".js-time-list").fadeOut();
}

function convertFaToEnNumber(number) {
  number = String(number);
  return number.replace(/[۰-۹]/g, function (chr) {
    var persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return persian.indexOf(chr);
  });
}

// Swap Elements
$.fn.swap = function (elem) {
  elem = elem.jquery ? elem : $(elem);
  return this.each(function () {
    $(document.createTextNode(""))
      .insertBefore(this)
      .before(elem.before(this))
      .remove();
  });
};
